<template>
    <!-- 飘窗效果 -->
    <div
            id="thediv"
            ref="thediv"
            v-show="thedivShow"
            @mouseover="clearFdAd"
            @mouseout="starFdAd"
    >
        <div
                style="
        cursor: pointer;
        text-align: right;
        font-size: 12px;
        color: #999999;
      "
                @click="thedivShow = false"
        >
            关闭
        </div>
        <div @click="goRegister">
            <!--//飘窗内容部分 图片或者视频 等等-->
            <img style="height: 200px;width: 160px;" src="../assets/img/home/pay.jpg" width="360" border="0"/>
            <!--<div class="tips" v-for="(cur, i) in defineIndexInfo" :key="i">-->
            <!--<div v-html="cur.noticeContent"></div>-->
            <!--</div>-->
        </div>

    </div>
<!--  <el-dialog :visible.sync="centerDialogVisible9"></el-dialog>-->

</template>

<script>
    export default {
      // props: {
      //   centerDialogVisible9: {
      //     type: String,
      //     default: false
      //   }
      // },
        name: "BayWindow",
        data() {

            return {
                //定义相关参数
                xPos: 0,
                yPos: 0,
                xin: true,
                yin: true,
                step: 3,
                delay: 34,
                height: 0,
                Hoffset: 0,
                Woffset: 0,
                yon: 0,
                xon: 0,
                pause: true,
                thedivShow: true,
                centerDialogVisible9:false
            };
        },

        created() {
            this.callLabList();//调用执行
        },
        mounted() {
            interval = setInterval(this.changePos, this.delay);
        },
        methods: {
            goRegister() {
              // this.centerDialogVisible9 = true
              //   this.$router.push({path: "/register"});
              //   this.$router.push({path: "../payDetail"});

                this.thedivShow = false;
            },
            //滚动逻辑方法
            changePos() {
                let width = document.documentElement.clientWidth;
                let height = document.documentElement.clientHeight;
                if (this.$refs.thediv) {
                    this.Hoffset = this.$refs.thediv.offsetHeight; //获取元素高度
                    this.Woffset = this.$refs.thediv.offsetWidth;
                    // 滚动部分不随屏幕滚动
                    this.$refs.thediv.style.left =
                        this.xPos + document.body.scrollLeft + "px";
                    this.$refs.thediv.style.top =
                        this.yPos + document.body.scrollTop + "px";

                    if (this.yon) {
                        this.yPos = this.yPos + this.step;
                    } else {
                        this.yPos = this.yPos - this.step;
                    }
                    if (this.yPos < 0) {
                        this.yon = 1;
                        this.yPos = 0;
                    }
                    if (this.yPos >= height - this.Hoffset) {
                        this.yon = 0;
                        this.yPos = height - this.Hoffset;
                    }

                    if (this.xon) {
                        this.xPos = this.xPos + this.step;
                    } else {
                        this.xPos = this.xPos - this.step;
                    }
                    if (this.xPos < 0) {
                        this.xon = 1;
                        this.xPos = 0;
                    }
                    if (this.xPos >= width - this.Woffset) {
                        this.xon = 0;
                        this.xPos = width - this.Woffset;
                    }
                }
                // 滚动时跟随屏幕滚动 需要时解开注释
                // this.$refs.thediv.style.left = (this.xPos +
                //document.body.scrollLeft + document.documentElement.scrollLeft) + "px";
                // this.$refs.thediv.style.top = (this.yPos +
                //document.body.scrollTop + document.documentElement.scrollTop) + "px";
            },
            clearFdAd() {
                clearInterval(interval);

            },
            starFdAd() {
                // interval = setInterval(this.changePos, this.delay);
            },
        },
    }
</script>

<style lang="less" scoped>
    #thediv {
        z-index: 100;
        position: absolute;
        top: 0px;
        left: 0px;
    }
</style>
